/** See Steps.tsx -- there should be corresponding order */
export const POST_APPLY_STEPS = [
  'screening-visit-qualification', // Experimental step for direct booking - some patients are routed here as a first step then go through a modified post-apply flow
  'share-trial', // only shown to unqualified patients - unqualified patients are more valuable as a referral source rather than a participant
  'you-are-a-match-q', // shown to 100% qualified patients only
  'patient-call-to-site-q', // shown to 100% qualified patients only
  'medical-release-consent',
  'medical-release-signature',
  'you-are-a-match',
  'patient-call-to-site',
  'phone-call-availability',
  'save-study-team-contact',
  'patient-navigator-agent',
  'why-apply',
  'share-story',
] as const

export type PostApplyStep = (typeof POST_APPLY_STEPS)[number]
